import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { getPlansBySectionId, clearSectionPlansFromStore } from 'actions/plans';
import { getEducationGroups } from 'actions/sections';
import { CardsContainer } from 'components/Cards/Card';
import LoadingCards from 'components/Cards/LoadingCard';
import SectionTitle from 'components/Presentation/SectionTitle';
import { PRESCHOOL } from 'constants/schoolTypes';
import PreschoolPlanningForm from 'containers/Forms/PlanningForm/PreschoolPlanningForm';
import SinglePlanForm from 'containers/Forms/PlanningForm/SinglePlanForm';
import SectionForm from 'containers/Forms/SectionForm';
import Modal from 'containers/Modals/Modal';
import { getRootUrl } from 'helpers/url';
import { isUserTeacher } from 'helpers/user';
import moment from 'moment';
import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { Button, Icon, getActiveLanguage } from '@haldor/ui';
import ReactGantt from '../../Gantt/ReactGantt';
import * as microsoftTeams from "@microsoft/teams-js";

var SectionPlans = /*#__PURE__*/function (_Component) {
  _inherits(SectionPlans, _Component);

  var _super = _createSuper(SectionPlans);

  function SectionPlans(props) {
    var _this;

    _classCallCheck(this, SectionPlans);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.props.clearSectionPlansFromStore();
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.initComponent();
    });

    _defineProperty(_assertThisInitialized(_this), "initComponent", function () {
      if (_this.props.groupid != null) {
        _this.setState({
          sectionId: _this.props.groupid
        });
      }

      _this.props.getPlansBySectionId(_this.props.groupid).then(function () {
        _this.getContext();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "parseRows", function (sectionId) {
      var _this$state = _this.state,
          groups = _this$state.groups,
          rows = _this$state.rows;
      var groupId = _this.props.groupid;

      if (sectionId != null) {
        groupId = sectionId;
      }

      if (_this.props.planning != null) {
        if (rows == null && _this.props.planning != null) {
          rows = [];

          _this.props.planning.map(function (planning) {
            // One planning object
            var isInGroups = groups.find(function (g_o) {
              return g_o.id == planning.sectionId;
            }); // Filter by groupid

            if (groupId && planning.sectionId != parseInt(groupId)) {
              return false;
            }

            var open = false;
            var showGroupTitle = true;

            if (window.location.pathname == '/planning-tab') {
              open = true;
              showGroupTitle = false;
            }

            if (!isInGroups) {
              var newGroup = {
                id: planning.sectionId,
                title: planning.section.title,
                open: open,
                showGroupTitle: showGroupTitle
              };
              groups.push(newGroup);
            }

            var url = "".concat(getRootUrl(), "plan/").concat(planning.id);
            var newRow = {
              title: planning.title,
              id: planning.id,
              borderLeft: "3px solid #997AE8",
              startDate: moment(planning.timeStart).toDate(),
              climaxDate: moment(planning.timeStart).add('6', 'hours').toDate(),
              planning: planning,
              groupColor: "grey",
              endDate: moment(planning.timeEnd).toDate(),
              group: planning.sectionId,
              action: function action() {
                _this.props.history.push(url);
              }
            };

            if (_this.props.dateRestriction && planning.status != 'PLANNING_CLOSED') {
              rows.push(newRow);
            } else if (_this.props.dateRestriction == false) {
              rows.push(newRow);
            }
          });

          _this.setState({
            groups: groups,
            rows: rows,
            sectionId: groupId
          }, function () {
            return true;
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "TaskList", function (plannings, i) {
      return /*#__PURE__*/React.createElement(CardsContainer, {
        key: "card-container-".concat(i)
      }, plannings.plannings.map(_this.PlanningCard));
    });

    _defineProperty(_assertThisInitialized(_this), "toggleIcon", function (flip) {
      return /*#__PURE__*/React.createElement("i", {
        className: "cl-container"
      }, /*#__PURE__*/React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        className: flip ? 'i-90' : 'a-90',
        style: {
          height: '12px',
          width: '15px',
          margin: 0
        }
      }, /*#__PURE__*/React.createElement("path", {
        id: "Path_50",
        "data-name": "Path 50",
        className: "cls-1",
        d: "M11.361,1.4,6.38,5.9,1.4,1.4"
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "CreateButton", function () {
      if (_this.props.disableCreate) {
        return null;
      }

      return /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: _this.openModal,
        disabled: _this.props.locked || _this.props.archived
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Plus"
      }), " ", _this.props.translate("Create"));
    });

    _defineProperty(_assertThisInitialized(_this), "goBackwards", function (event) {
      event.preventDefault();
      var options = _this.state.options;
      var leftBound = moment(options.leftBound).subtract('1', 'weeks').toDate();
      var maxLeftBound = moment().startOf('week').subtract('20', 'weeks').toDate();

      if (leftBound > maxLeftBound || _this.props.dateRestriction == false) {
        options.leftBound = leftBound;
        options.rightBound = moment(options.rightBound).subtract('1', 'weeks').toDate();

        _this.setState({
          options: options
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "goForwards", function (event) {
      event.preventDefault();
      var options = _this.state.options;
      var rightBound = moment(options.rightBound).add('1', 'weeks').toDate();
      var maxRightBound = moment().endOf('week').add('4', 'weeks').add('20', 'weeks').toDate();

      if (rightBound < maxRightBound || _this.props.dateRestriction == false) {
        options.leftBound = moment(options.leftBound).add('1', 'weeks').toDate();
        options.rightBound = rightBound;

        _this.setState({
          options: options
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "openModal", function () {
      _this.setState({
        modalIsOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeModal", function () {
      _this.setState({
        modalIsOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "teamsTabCloseForm", function () {
      _this.setState({
        noSectionFound: false
      }, function () {
        window.location = window.location.href;
      });
    });

    moment.locale(getActiveLanguage());
    var momentDate = moment();
    _this.state = {
      modalIsOpen: false,
      rows: null,
      groups: [],
      sectionId: null,
      noSectionFound: false,
      teamsContext: null,
      options: {
        labelWidth: '20%',
        labelBorderColor: '#E4E4EB',
        labelAppendBeforeFormat: _this.props.translate('week'),
        intervalFormat: 'W',
        showBorders: false,
        responsive: true,
        bootstrapped: true,
        leftBound: momentDate.startOf('week').toDate(),
        rightBound: momentDate.endOf('week').add('3', 'weeks').toDate(),
        placeholder: '',
        beforeClimaxColor: 'white',
        afterClimaxColor: 'white',
        hideFirstColumn: true,
        barStyle: {
          height: '105px',
          border: '1px solid #E4E4EB',
          showTitle: true,
          shadow: false,
          borderRadius: '4px',
          hoverPopup: false,
          showGroupTitle: true
        }
      }
    };
    return _this;
  }

  _createClass(SectionPlans, [{
    key: "getContext",
    value: function getContext() {
      var _this2 = this;

      var isFrame = this.isIframe();

      if (isFrame) {
        if (window.location.pathname == '/planning-tab') {
          microsoftTeams.app.getContext().then(function (context) {
            var section = _this2.props.sections.find(function (section) {
              return section.graphId == context.team.groupId;
            });

            if (section != null) {
              _this2.setState({
                sectionId: section.id,
                noSectionFound: false
              });

              _this2.parseRows(section.id);
            } else {
              _this2.setState({
                noSectionFound: true,
                teamsContext: context
              });
            }
          });
        } else {
          this.parseRows();
        }
      } else {
        this.parseRows();
      }
    }
  }, {
    key: "isIframe",
    value: function isIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          rows = _this$state2.rows,
          groups = _this$state2.groups,
          modalIsOpen = _this$state2.modalIsOpen,
          options = _this$state2.options;
      var _this$props = this.props,
          planning = _this$props.planning,
          currentUser = _this$props.currentUser;
      var isTeacher = isUserTeacher(this.props.currentUser);
      return /*#__PURE__*/React.createElement("div", {
        className: "section",
        id: "section-planning"
      }, /*#__PURE__*/React.createElement("div", {
        className: "my_planning planning"
      }, /*#__PURE__*/React.createElement(Modal, {
        isOpen: modalIsOpen,
        onClose: this.closeModal,
        title: this.props.translate('plan-create-button')
      }, this.props.currentUser.schools.getActiveSchool(this.props.currentUser.userId).type === PRESCHOOL ? /*#__PURE__*/React.createElement(PreschoolPlanningForm, {
        onAbort: this.closeModal,
        editView: false,
        cloneView: false,
        sectionId: this.props.groupid != null ? this.props.groupid : this.state.sectionId
      }) : /*#__PURE__*/React.createElement(SinglePlanForm, {
        onAbort: this.closeModal,
        editView: false,
        cloneView: false,
        sectionId: this.props.groupid != null ? this.props.groupid : this.state.sectionId
      })), /*#__PURE__*/React.createElement(SectionTitle, null, /*#__PURE__*/React.createElement(Icon, {
        name: "Plans"
      }), /*#__PURE__*/React.createElement("span", null, this.props.translate('planning-header-overview')), isTeacher && this.state.noSectionFound == false ? this.CreateButton() : null, this.props.dateRestriction ? /*#__PURE__*/React.createElement(Link, {
        to: "plans",
        className: "see-more"
      }, this.props.translate('show-all-plans')) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          "float": 'right'
        }
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        style: {
          marginLeft: 0,
          marginRight: '0.5em'
        },
        onClick: this.goBackwards
      }, this.toggleIcon(false), "\xA0"), /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        style: {
          marginLeft: 0
        },
        onClick: this.goForwards
      }, this.toggleIcon(true), "\xA0"))), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: 'both'
        }
      }), planning != null && rows != null && rows.length == 0 ? /*#__PURE__*/React.createElement("div", {
        style: {
          width: '100%',
          textAlign: 'center'
        }
      }, this.props.planning != null ? this.props.planning.length > 0 ? /*#__PURE__*/React.createElement("h3", null, this.props.translate('no-plans-created'), isTeacher && this.state.noSectionFound == false ? this.CreateButton() : null) : null : null) : rows != null ? /*#__PURE__*/React.createElement("div", {
        className: "gantt-container"
      }, /*#__PURE__*/React.createElement(ReactGantt, {
        options: options,
        groups: groups,
        sections: this.props.sections,
        rows: rows,
        weekTranslation: this.props.translate('week')
      })) : this.state.noSectionFound == false ? /*#__PURE__*/React.createElement(LoadingCards, {
        count: 1
      }) : null, this.state.noSectionFound && isTeacher ? /*#__PURE__*/React.createElement(SectionForm, {
        editView: false,
        teamsContext: this.state.teamsContext,
        teamsTabCloseForm: this.teamsTabCloseForm,
        tab: "planning"
      }) : null));
    }
  }]);

  return SectionPlans;
}(Component);

function mapStateToProps(state) {
  return {
    planning: state.planning.sectionPlans,
    sections: state.sections.educationGroups,
    translate: translate(state.Languages.translations),
    languages: state.Languages.languages,
    currentUser: state.user.currentUser
  };
}

export default withRouter(connect(mapStateToProps, {
  getPlansBySectionId: getPlansBySectionId,
  getEducationGroups: getEducationGroups,
  clearSectionPlansFromStore: clearSectionPlansFromStore
})(SectionPlans));